import { ConfigActionsTypes, ConfigState } from './types';

export const initialState: ConfigState = {
  data: undefined,
  errors: undefined,
  loading: false
}

export const ConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case ConfigActionsTypes.CONFIG_MESSAGESCONFIGURATION_REQUEST:
      return {
        ...state,
        messageConfig: { ...state?.messageConfig, loading: true },
    };
    case ConfigActionsTypes.CONFIG_MESSAGESCONFIGURATION_SUCCESS:
      return {
        ...state,
        messageConfig: {
            ...state.messageConfig,
            messages: action.payload,
            loading: false,
        },
    };
    case ConfigActionsTypes.CONFIG_MESSAGESCONFIGURATION_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload
    };
    default:
      return state;
  }
}